// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CsrRepModel } from "@insite/client-framework/Types/ApiModels";
import { ContactUsGreifState } from "@store/Framework/Store/Greif/Pages/ContactUs/ContactUsState";
import { Draft } from "immer";

const initialState: ContactUsGreifState = {
    resetValues: false,
    plantFieldValues: {
        address: "",
        cellPhone: "",
        email: "",
        firstName: "",
        lastName: "",
        officePhone: "",
        role: "",
        isDefaultPlant: false,
        plant: "",
        plantDisplayName: "",
    },
};

const actions = {
    "Greif/Pages/ContactUs/ResetValues": (draft: Draft<ContactUsGreifState>) => {
        draft.resetValues = !draft.resetValues;
    },
    "Greif/Pages/ContactUs/ClearForm": (draft: Draft<ContactUsGreifState>) => {
        draft.shipTo = "";
        draft.soldTo = "";
        draft.billingAddress = "";
        draft.customerNumber = "";
    },
    "Greif/Pages/ContactUs/SetPlantFieldValue": (draft: Draft<ContactUsGreifState>, action: { value: CsrRepModel }) => {
        draft.plantFieldValues = action.value;
    },
    "Greif/Pages/ContactUs/SetSoldToValue": (draft: Draft<ContactUsGreifState>, action: { value: string }) => {
        draft.soldTo = action.value;
    },
    "Greif/Pages/ContactUs/SetShipToValue": (draft: Draft<ContactUsGreifState>, action: { value: string }) => {
        draft.shipTo = action.value;
    },
    "Greif/Pages/ContactUs/SetBillingAddress": (draft: Draft<ContactUsGreifState>, action: { value: string }) => {
        draft.billingAddress = action.value;
    },
    "Greif/Pages/ContactUs/SetCustomerNumber": (draft: Draft<ContactUsGreifState>, action: { value: string }) => {
        draft.customerNumber = action.value;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifContactUsPageReducer = Parameters<typeof reducer>[1];
export default reducer;
